import { Mark, mergeAttributes, type RawCommands } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    banhMiMoment: {
      setBanhMiMoment: (attributes: { tooltip: string }) => ReturnType;
      unsetBanhMiMoment: () => ReturnType;
    };
  }
}

export const BanhMiMomentMark = Mark.create({
  name: "banhMiMoment",

  addAttributes() {
    return {
      tooltip: {
        default: "",
        parseHTML: (element: HTMLElement) => element.getAttribute("data-tooltip") || "",
        renderHTML: (attributes: Record<string, string>) => ({
          "data-tooltip": attributes.tooltip,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: "span.bm-moment" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes({ class: "bm-moment", tabindex: "0" }, HTMLAttributes), 0];
  },

  addCommands() {
    return {
      setBanhMiMoment:
        (attributes: { tooltip: string }) =>
        ({ commands }) =>
          commands.setMark(this.name, attributes),
      unsetBanhMiMoment:
        () =>
        ({ commands }) =>
          commands.unsetMark(this.name),
    } as Partial<RawCommands>;
  },
});
